import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsageDetailsComponent } from './usage/usage-details.component';



const routes: Routes = [
  { path: 'usage', component: UsageDetailsComponent }
  ];
@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}


// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts